import { useEffect, useState } from 'react';
import type { TermlyConsentCategory } from '../config/termly';
import { subscribeToTermlyConsent } from '../utils/termlyConsent';

export function useTermlyConsentCategory(category: TermlyConsentCategory): boolean {
  const [consented, setConsented] = useState(false);

  useEffect(() => {
    return subscribeToTermlyConsent((state) => {
      setConsented(Boolean(state?.[category]));
    });
  }, [category]);

  return consented;
}
